import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBlockSortDescending: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="block-sort-descending"><path d="M10.25 3.75H3.75V10.25H10.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M10.25 13.75H3.75V20.25H10.25V13.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M18 16.5V6" stroke="currentColor" strokeWidth="1.5"/><path d="M13.75 12.75L18 17L22.25 12.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBlockSortDescending;
